(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
class KsMarquee extends HTMLElement {
  connectedCallback () {
    if (this._ready) return
    const list = this.querySelector('ul')
    if (!list) return
    this._ready = true
    this._list = list
    this._baseHTML = list.innerHTML
    this._originalCount = list.children.length

    // Build after layout so widths are real (constructor/connect can be pre-layout),
    // and rebuild after images load and on resize so it always fills the width.
    requestAnimationFrame(() => this.build())
    window.addEventListener('load', () => this.build())
    let t
    window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => this.build(), 200) })
  }

  build () {
    const list = this._list
    if (!list) return

    // Reset to a single base set to measure its true width.
    list.style.animation = 'none'
    list.innerHTML = this._baseHTML
    const baseWidth = list.scrollWidth
    const container = Math.round(this.getBoundingClientRect().width) || window.innerWidth
    if (!baseWidth || !container) { list.style.animation = ''; return }

    // Repeat the set so ONE half is at least as wide as the container (+1 buffer),
    // then duplicate that half. Translating the track by -50% then loops seamlessly.
    const perHalf = Math.max(1, Math.ceil(container / baseWidth) + 1)
    list.innerHTML = this._baseHTML.repeat(perHalf) + this._baseHTML.repeat(perHalf)

    // Hide clones from assistive tech (keep only the first real set announced).
    Array.from(list.children).forEach((item, index) => {
      if (index >= this._originalCount) item.setAttribute('aria-hidden', 'true')
    })

    // Keep perceived scroll speed constant regardless of how many repeats.
    const baseDuration = parseFloat(this.dataset.animationDuration) || 30
    const duration = baseDuration * perHalf
    const toRight = this.dataset.marqueeDirection === 'right'
    const id = this.dataset.sectionId

    let styleEl = document.getElementById('marquee-style-' + id)
    if (!styleEl) {
      styleEl = document.createElement('style')
      styleEl.id = 'marquee-style-' + id
      this.parentNode.insertBefore(styleEl, this)
    }
    styleEl.textContent = `
      #marquee-${id} ul {
        animation-name: marquee-animation-${id};
        animation-duration: ${duration}s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
      @keyframes marquee-animation-${id} {
        from { transform: translateX(${toRight ? '-50%' : '0'}); }
        to   { transform: translateX(${toRight ? '0' : '-50%'}); }
      }
    `
    list.style.animation = ''
  }
}
customElements.define('ks-marquee', KsMarquee)


  } catch(e) { console.error(e); }
})();
})();
